// WSZ Analytics — cookieless entry point.
// No cookies, no client-side identifiers. Server derives anonymous hashes from IP+UA+daily-salt.
import { isBot, respectsDnt } from "./bot-detect.js";
import { createQueue } from "./queue.js";
import { attachEventTrackers } from "./events.js";
import { attachWebVitals } from "./vitals.js";

function init() {
  if (respectsDnt()) return;
  if (isBot()) return;

  const meta = {
    locale: document.documentElement.lang || null,
    referrer: document.referrer || null,
  };

  const queue = createQueue(meta);
  queue.start();
  attachEventTrackers(queue);
  attachWebVitals(queue);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}
